import styled from 'react-emotion';

export const ZoomWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;

export const ZoomTriggerWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  user-select: none;
  cursor: ${props => (props.canZoom ? (props.isZoomed ? 'zoom-out' : 'zoom-in') : 'default')};
  touch-action: ${props => (props.isZoomed || props.inPopup ? 'none' : 'pinch-zoom pan-y')};
`;
